import getPatientCareGaps from "../../Caregaps/getPatientCareGaps";

/**
 * Returns the structured list of care gaps for a patient.
 *
 * Routes to GET /api/CareGap/patient/{cipId} (the same endpoint the CareGaps module
 * uses) so the count chip in Patient Map and the drill-down in the CareGaps module
 * stay in sync. The previous endpoint (/api/PatientInfo/{cipId}/care-gaps) diverged
 * from /api/CareGap/patient/{cipId} on the backend, hiding gaps for some patients.
 *
 * Items are normalized to the shape consumed by the Care Gaps tab in ClinicalSummary
 * — same mapping used by loadCareGapsByPatient in CareGapContext.
 *
 * @param {string} cipId
 * @returns {Promise<Array>} Mapped care gap items (empty array if none)
 */
export const getCareGapsByCip = async (cipId) => {
  const result = await getPatientCareGaps(cipId, 1, 100);
  const rawItems = Array.isArray(result?.data) ? result.data : [];

  return rawItems.map((row) => ({
    id: row.careGapId,
    careGapId: row.careGapId,
    careGapName: row.careGapName,
    patientName: row.patientFullName,
    patientFullName: row.patientFullName,
    cipId: row.cipId,
    pcpName: row.pcpName,
    status: row.workflowStatusCode,
    workflowStatusCode: row.workflowStatusCode,
    workflowStatus: row.workflowStatus,
    sourceStatusCode: row.sourceStatusCode,
    sourceStatus: row.sourceStatus,
    lastUpdated: row.lastUpdateDate,
    createdDate: row.createdDate,
    submittedDate: row.submittedDate,
    serviceClosureDate: row.serviceDateOfClosure,
    measurementYear: row.measurementYear,
    refreshWeek: row.measurementYearRefreshWeek,
    historicallyNonCompliant: row.historicallyNonCompliant,
    assignedEmployeeId: row.assignedEmployeeId,
    priority: row.priority,
    evidenceCount: row.evidenceCount,
    outreachCount: row.outreachCount,
    legacySourceTable: row.legacySourceTable,
    legacyUploadId: row.legacyUploadId,
  }));
};
